import { useState, useEffect } from 'react';

// Delays reflecting `value` until it's stayed the same for `delayMs` — e.g.
// a search field that shouldn't fire a request on every keystroke.
// Extracted from SafetyFlagsView.js (previously defined locally there, the
// only admin filter with debounced search) so every admin search/filter
// field — including the shared FilterBar primitive — shares one
// implementation instead of each view growing its own copy.
export default function useDebouncedValue(value, delayMs) {
  const [debounced, setDebounced] = useState(value);
  useEffect(() => {
    const timer = setTimeout(() => setDebounced(value), delayMs);
    return () => clearTimeout(timer);
  }, [value, delayMs]);
  return debounced;
}
